import React, { useEffect, useRef } from "react";
import { Button, Modal, Form as BTForm } from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import FormSelectBox from "src/components/Forms/FormSelectBox";
import FormPriceInput from "src/components/Forms/FormPriceInput";
import { useState } from "react";

const EditPriceDialog = ({
  show,
  toggle,
  price = {},
  handleSuccess = null,
}) => {
  function validate(values) {
    const errors = {};

    if (!values.parking_slot_category_id) {
      errors.parking_slot_category_id = "Kategorie ist ein Pflichtfeld.";
    }

    if (!values.season_id) {
      errors.season_id = "Saison ist ein Pflichtfeld.";
    }

    if (!values.price) {
      errors.price = "Preis ist ein Pflichtfeld.";
    }

    return errors;
  }

  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);
    let request;

    if (price.id) {
      request = axios.put(`/api/v1/prices/${price.id}.json`, {
        price: values,
      });
    } else {
      request = axios.post(`/api/v1/prices.json`, {
        price: values,
      });
    }

    request
      .then(function () {
        toggle();
        handleSuccess();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      });
  }

  const [template, setTemplate] = useState();
  const formRef = useRef();

  useEffect(() => {
    fetchTemplate();
  }, []);

  const fetchTemplate = () => {
    axios
      .get(`/api/v1/prices/template.json`)
      .then(function (response) {
        setTemplate(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSubmit = () => {
    formRef.current.handleSubmit();
  };

  const findInitAgeGroup = () => {
    if (Object.keys(price).length == 0) {
      return template?.age_group_id ?? "";
    }

    return price.age_group_id ?? "Stellplatz";
  };

  return (
    <Modal show={show} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>{!price.id ? "Erstellen" : "Bearbeiten"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{
            parking_slot_category_id:
              price.parking_slot_category_id ??
              template?.parking_slot_category_id ??
              "",
            season_id: price.season_id ?? template?.season_id ?? "",
            age_group_id: findInitAgeGroup(),
            price: price.price ?? template?.price ?? "",
            price_unit: price.price_unit,
          }}
          validate={validate}
          onSubmit={submit}
        >
          {({ values }) => (
            <Form autoComplete="false">
              <FormSelectBox
                name="parking_slot_category_id"
                label="Kategorie"
                options={template.settings.parking_slot_categories}
                option_value="id"
                option_name="name"
                required
              />
              <FormSelectBox
                name="season_id"
                label="Saison"
                options={template.settings.seasons}
                option_value="id"
                option_name="name"
                required
              />
              <FormSelectBox
                name="price_unit"
                label="Preis Pro"
                options={template.settings.price_units}
                option_value="id"
                option_name="name"
                required
              />

              {values.price_unit === "person" && (
                <FormSelectBox
                  name="age_group_id"
                  label="Altersgruppe"
                  options={template.settings.age_groups}
                  option_value="id"
                  option_name="name"
                  required
                />
              )}
              <FormPriceInput
                name="price"
                label="Preis"
                placeholder="0.00"
                required
              />
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPriceDialog;
